<!--

RoadList
--------

-->

<template>
    <div class="road-list d-flex flex-column border border-primary">
        <div class="text-white bg-primary p-1"
            v-if="sortedRoads.length > 0">
            Roads showing
        </div>
        <div v-for="number in sortedRoads" :key="number"
            class="m-1 bg-white border border-primary rounded d-flex justify-content-between">
            <span class="px-2 py-1">A{{number}}</span>
            <span class="text-primary text-link d-block px-2 py-1"
                v-on:click="removeRoad(number)">&times;</span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .road-list {
        position: absolute;
        right: 20px;
        top: 20px;
        max-height: calc(100vh - 40px);
        overflow-y: scroll;
    }

    .rounded {
        border-radius: 20px !important
    }
</style>

<script>
    import {mapGetters} from 'vuex'

    export default {
        computed: {
            ...mapGetters('roads', ['sortedRoads'])
        },
        methods: {
            removeRoad(number) {
                this.$emit('remove-road', number);
            }
        }
    }
</script>